/* global NDEFReader */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import moment from 'moment';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './HHBitacoraPage.css';
import API_BASE_URL from '../config';

const BitacoraPage = () => {
  const [registros, setRegistros] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 8;
  const [selectedRegistro, setSelectedRegistro] = useState(null);

  const [showEntradaModal, setShowEntradaModal] = useState(false);
  const [showSalidaModal, setShowSalidaModal] = useState(false);
  const [showAlimentosNfcModal, setShowAlimentosNfcModal] = useState(false);
  const [alimentosMode, setAlimentosMode] = useState(null); // 'start' | 'end'
  const [targetRegistroAlimentos, setTargetRegistroAlimentos] = useState(null);

  // Estados para evitar llamadas duplicadas (procesamiento)
  const [isProcessingEntrada, setIsProcessingEntrada] = useState(false);
  const [isProcessingSalida, setIsProcessingSalida] = useState(false);
  const [isProcessingAlimentos, setIsProcessingAlimentos] = useState(false);

  const [showEntradaCredencialModal, setShowEntradaCredencialModal] = useState(false);
const [credencialValidada, setCredencialValidada] = useState(false);
const [nfcCredencial, setNfcCredencial] = useState('');


  const token = useSelector((state) => state.auth.token);
  const decoded = token ? jwtDecode(token) : null;
  const estacionUsuario = decoded?.estacion?.trim().toUpperCase();

  useEffect(() => {
    const fetchRegistros = async () => {
      if (!token || !estacionUsuario) return;
      try {
        const response = await axios.get(
          `${API_BASE_URL}api/bitacora/dia`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
  
        const data = response.data || [];
  
        const registrosFiltrados = data.filter(
          (r) => r.estacion?.trim().toUpperCase() === estacionUsuario
        );
  
        setRegistros(registrosFiltrados);
      } catch (error) {
        console.error('Error al obtener los registros:', error);
      }
    };
  
    fetchRegistros();
  }, [token, estacionUsuario]);
  
  

  // Filtrado por No. Colaborador o Siglas (buscador)
  const filteredRegistros = registros.filter((registro) => {
    const searchLower = searchQuery.toLowerCase();
    const noColaborador = registro.noColaborador
      ? registro.noColaborador.toString().toLowerCase()
      : '';
    const siglas = registro.siglas ? registro.siglas.toLowerCase() : '';
    return noColaborador.includes(searchLower) || siglas.includes(searchLower);
  });

  const totalPages = Math.ceil(filteredRegistros.length / pageSize);
  const currentRecords = filteredRegistros.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  /* Lógica NFC para Registro de Entrada */
  useEffect(() => {
    if (showEntradaModal) {
      // Reiniciamos el estado para evitar lecturas anteriores
      setIsProcessingEntrada(false);
      if ('NDEFReader' in window) {
        const reader = new NDEFReader();
        const startNFC = async () => {
          try {
            await reader.scan();
            toast.info('Acerque su tarjeta NFC...', { autoClose: 1000 });
            reader.onreading = async (event) => {
              // Si ya se está procesando, se ignora la lectura
              if (isProcessingEntrada) return;
              if (event.message.records && event.message.records.length > 0) {
                const record = event.message.records[0];
                const nfcData = record.data
                  ? new TextDecoder().decode(record.data)
                  : 'Datos no disponibles';
                //toast.info(`Datos leídos de NFC: ${nfcData}`, { autoClose: 2000 });
                handleScanEntrada(nfcData);
              } else {
                toast.warn('No se encontraron registros en el mensaje NFC', {
                  autoClose: 1000,
                });
                setTimeout(() => {
                  setShowEntradaModal(false);
                }, 1000);
              }
            };
          } catch (error) {
            toast.error('Error al activar el lector NFC', { autoClose: 1000 });
            setTimeout(() => {
              setShowEntradaModal(false);
            }, 1000);
          }
        };
        startNFC();
      } else {
        toast.warn('NFC no es compatible con este dispositivo.', { autoClose: 1000 });
        setTimeout(() => {
          setShowEntradaModal(false);
        }, 1000);
      }
    }
  }, [showEntradaModal]);

  const handleScanEntrada = async (nfc_id) => {
    if (!token) {
      toast.error('Error: Token no encontrado.', { autoClose: 1000 });
      setTimeout(() => {
        setShowEntradaModal(false);
      }, 1000);
      return;
    }
    try {
      const response = await axios.post(
        `${API_BASE_URL}api/bitacora`,
        { nfc_id },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Registro exitoso', { autoClose: 1000 });
      setTimeout(() => {
        setShowEntradaModal(false);
        window.location.reload();
      }, 1000);
    } catch (error) {
      const errorMsg = error.response
        ? error.response.data.error || 'Error en el servidor'
        : 'Error en el servidor';
      toast.error(errorMsg, { autoClose: 1000 });
      setTimeout(() => {
        setShowEntradaModal(false);
      }, 1000);
    }
  };

  /* Lógica NFC para Registro de Salida */
  useEffect(() => {
    if (showSalidaModal) {
      // Reiniciamos el estado para evitar lecturas anteriores
      setIsProcessingSalida(false);
      if ('NDEFReader' in window) {
        const reader = new NDEFReader();
        const startNFC = async () => {
          try {
            await reader.scan();
            toast.info('Acerque su tarjeta NFC...', { autoClose: 1000 });
            reader.onreading = async (event) => {
              if (isProcessingSalida) return;
              if (event.message.records && event.message.records.length > 0) {
                const record = event.message.records[0];
                const nfcData = record.data
                  ? new TextDecoder().decode(record.data)
                  : 'Datos no disponibles';
                //toast.info(`Datos leídos de NFC: ${nfcData}`, { autoClose: 2000 });
                handleScanSalida(nfcData);
              } else {
                toast.warn('No se encontraron registros en el mensaje NFC', {
                  autoClose: 1000,
                });
                setTimeout(() => {
                  setShowSalidaModal(false);
                }, 1000);
              }
            };
          } catch (error) {
            toast.error('Error al activar el lector NFC', { autoClose: 1000 });
            setTimeout(() => {
              setShowSalidaModal(false);
            }, 1000);
          }
        };
        startNFC();
      } else {
        toast.warn('NFC no es compatible con este dispositivo.', { autoClose: 1000 });
        setTimeout(() => {
          setShowSalidaModal(false);
        }, 1000);
      }
    }
  }, [showSalidaModal]);

  /* Lógica NFC para Iniciar/Finalizar Alimentos */
  useEffect(() => {
    if (showAlimentosNfcModal) {
      setIsProcessingAlimentos(false);
      if ('NDEFReader' in window) {
        const reader = new NDEFReader();
        const startNFC = async () => {
          try {
            await reader.scan();
            toast.info('Acerque su tarjeta NFC...', { autoClose: 1000 });
            reader.onreading = async (event) => {
              if (isProcessingAlimentos) return;
              if (event.message.records && event.message.records.length > 0) {
                const record = event.message.records[0];
                const nfcData = record.data ? new TextDecoder().decode(record.data) : '';
                handleScanAlimentos(nfcData);
              } else {
                toast.warn('No se encontraron registros en el NFC', { autoClose: 1000 });
                setTimeout(() => setShowAlimentosNfcModal(false), 1000);
              }
            };
          } catch (error) {
            toast.error('Error al activar el lector NFC', { autoClose: 1000 });
            setTimeout(() => setShowAlimentosNfcModal(false), 1000);
          }
        };
        startNFC();
      } else {
        toast.warn('NFC no es compatible con este dispositivo.', { autoClose: 1000 });
        setTimeout(() => setShowAlimentosNfcModal(false), 1000);
      }
    }
  }, [showAlimentosNfcModal]);

  const handleScanAlimentos = async (nfc_id) => {
    if (!token) {
      toast.error('Error: Token no encontrado.', { autoClose: 1000 });
      setTimeout(() => setShowAlimentosNfcModal(false), 1000);
      return;
    }
    try {
      // 1) Validar pulsera
      const pRes = await axios.get(`${API_BASE_URL}api/pulseras/${nfc_id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const pulsera = pRes.data;
      if (!pulsera) throw new Error('Pulsera no registrada');
      if ((pulsera.estacion || '').trim().toUpperCase() !== (estacionUsuario || '')) {
        throw new Error('La pulsera no pertenece a la estación del usuario.');
      }
      const registro = targetRegistroAlimentos;
      if (!registro) throw new Error('Registro objetivo no definido.');
      // Validar que la pulsera coincida con el registro seleccionado
      if (String(pulsera.noColaborador) !== String(registro.noColaborador)) {
        throw new Error('La pulsera no coincide con el colaborador del registro.');
      }

      // 3) Alternar estado: si ya está en Alimentos, se registra hora fin; si no, se inicia
      const ahora = moment().format('YYYY-MM-DD HH:mm:ss');
      let payload = {};
      if (alimentosMode === 'start') {
        payload = { status: 'Alimentos', horaInicioAlimentos: ahora, horaFinAlimentos: null };
      } else if (alimentosMode === 'end') {
        payload = { status: 'En Turno', horaFinAlimentos: ahora };
      } else {
        throw new Error('Modo de alimentos inválido.');
      }

      await axios.put(`${API_BASE_URL}api/bitacora/${registro._id}`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const msg = alimentosMode === 'end' ? 'Fin de Alimentos registrado' : 'Inicio de Alimentos registrado';
      toast.success(msg, { autoClose: 1000 });
      setTimeout(() => {
        setShowAlimentosNfcModal(false);
        window.location.reload();
      }, 1000);
    } catch (error) {
      const errorMsg = error.response?.data?.error || error.message || 'Error en el servidor';
      toast.error(errorMsg, { autoClose: 1000 });
      setTimeout(() => setShowAlimentosNfcModal(false), 1000);
    }
  };

  const handleScanSalida = async (nfc_id) => {
    if (!token) {
      toast.error('Error: Token no encontrado.', { autoClose: 1000 });
      setTimeout(() => {
        setShowSalidaModal(false);
      }, 1000);
      return;
    }
    try {
      const response = await axios.put(
        `${API_BASE_URL}api/bitacora/salida`,
        { nfc_id },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Salida registrada exitosamente', { autoClose: 1000 });
      setTimeout(() => {
        setShowSalidaModal(false);
        window.location.reload();
      }, 1000);
    } catch (error) {
      const errorMsg = error.response
        ? error.response.data.error || 'Error en el servidor'
        : 'Error en el servidor';
      toast.error(errorMsg, { autoClose: 1000 });
      setTimeout(() => {
        setShowSalidaModal(false);
        window.location.reload();
      }, 1000);
    }
  };

  // Handlers de paginación
  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handleScanCredencial = async () => {
    if ('NDEFReader' in window) {
      try {
        const reader = new NDEFReader();
        await reader.scan();
        toast.info('Escaneando credencial...', { autoClose: 1000 });
  
        reader.onreading = async (event) => {
          const record = event.message.records[0];
          const nfcData = new TextDecoder().decode(record.data);
  
          try {
            const response = await axios.get(`${API_BASE_URL}api/pulseras/${nfcData}`, {
              headers: { Authorization: `Bearer ${token}` },
            });
            if (response.data) {
              setCredencialValidada(true);
              setNfcCredencial(nfcData);
              toast.success('Pulsera validada');
            }
          } catch (error) {
            toast.error('Pulsera no registrada');
          }
        };
      } catch (error) {
        toast.error('Error al activar lector NFC');
      }
    } else {
      toast.error('Dispositivo no compatible con NFC');
    }
  };
  
  

const handleRegistrarEntradaCompleta = async () => {
  try {
    const response = await axios.post(`${API_BASE_URL}api/bitacora/nueva-entrada`, {
      nfc_id: nfcCredencial,
      noSilla: 'SILLA MEX',
    }, {
      headers: { Authorization: `Bearer ${token}` },
    });

    toast.success('Entrada registrada');
    setTimeout(() => {
      setShowEntradaCredencialModal(false);
      window.location.reload();
    }, 1000);
  } catch (error) {
    toast.error('Error al registrar entrada');
  }
};


  return (
    
    <div className="bitacora-container">
      <h3>Estación actual: {estacionUsuario}</h3>

      <h1>Bitácora de Operadores</h1>
      <div className="botones-registro">
      <button className="registro-button" onClick={() => {
  setShowEntradaCredencialModal(true);
  setCredencialValidada(false);

}}>
  Registrar Entrada
</button>

        <button className="registro-button salida" onClick={() => {setShowSalidaModal(true); setIsProcessingSalida(false)}}>
          Registrar Salida
        </button>
      </div>

      {/* Buscador */}
      <div className="buscador-container">
        <input
          type="text"
          placeholder="Buscar por No. Colaborador o Siglas..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }}
        />
      </div>

      {/* Listado de tarjetas compactas */}
      <div className="tarjetas-container">
        {currentRecords.length === 0 ? (
          <p>No hay registros para mostrar.</p>
        ) : (
          currentRecords.map((registro, index) => (
            <div
              key={index}
              className={`tarjeta-compacta${registro.status === 'Alimentos' ? ' alimentos' : ''}`}
              onClick={() => setSelectedRegistro(registro)}
            >
              <span>{registro.noFila || 'N/A'}</span> -{' '}
              <span>
                {registro.noColaborador || 'N/A'}{' '}
                {registro.siglas ? `(${registro.siglas})` : ''}
              </span>{' '}
              - <span>{registro.status || 'N/A'}</span>
              <div className="alimentos-actions">
                <button
                  className="btn-alimentos start"
                  title="Iniciar Alimentos"
                  onClick={(e) => {
                    e.stopPropagation();
                    setTargetRegistroAlimentos(registro);
                    setAlimentosMode('start');
                    setShowAlimentosNfcModal(true);
                  }}
                >
                  🍽️ Iniciar
                </button>
                <button
                  className="btn-alimentos end"
                  title="Finalizar Alimentos"
                  onClick={(e) => {
                    e.stopPropagation();
                    setTargetRegistroAlimentos(registro);
                    setAlimentosMode('end');
                    setShowAlimentosNfcModal(true);
                  }}
                >
                  ✅ Finalizar
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Paginación */}
      {totalPages > 1 && (
        <div className="paginacion">
          <button onClick={handlePrevPage} disabled={currentPage === 1}>
            {'<'}
          </button>
          <span>
            Página {currentPage} de {totalPages}
          </span>
          <button onClick={handleNextPage} disabled={currentPage === totalPages}>
            {'>'}
          </button>
        </div>
      )}

      {/* Modal de Detalle del Registro */}
      {selectedRegistro && (
        <div className="modal" onClick={() => setSelectedRegistro(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>Detalle del Registro</h2>
            <div className="detalle-info">
              <p>
                <strong>No. Fila:</strong> {selectedRegistro.noFila || 'N/A'}
              </p>
              <p>
                <strong>No. Colaborador:</strong>{' '}
                {selectedRegistro.noColaborador || 'N/A'}{' '}
                {selectedRegistro.siglas && `(${selectedRegistro.siglas})`}
              </p>
              <p>
                <strong>Entrada:</strong>{' '}
                {selectedRegistro.entrada
                  ? new Date(selectedRegistro.entrada).toLocaleString()
                  : 'No registrada'}
              </p>
              <p>
                <strong>Salida:</strong>{' '}
                {selectedRegistro.salida
                  ? new Date(selectedRegistro.salida).toLocaleString()
                  : 'No registrada'}
              </p>
              <p>
                <strong>Registrado Por:</strong> {selectedRegistro.register_by || 'N/A'}
              </p>
              <p>
                <strong>Último Servicio:</strong> {selectedRegistro.ultimoServicio || 'N/A'}
              </p>
              <p>
                <strong>Status:</strong> {selectedRegistro.status || 'N/A'}
              </p>
            </div>
            <div className="modal-actions">
              <button onClick={() => setSelectedRegistro(null)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal para Registro de Entrada (NFC) */}
      {showEntradaModal && (
        <div className="modal" onClick={() => setShowEntradaModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>Registro de Entrada</h2>
            {/* No se muestran mensajes aquí; se usan toast */}
          </div>
        </div>
      )}

      {showSalidaModal && (
  <div className="modal" onClick={() => setShowSalidaModal(false)}>
    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
      <h2>Registro de Salida</h2>
      <p>Acerque su tarjeta NFC para registrar la salida.</p>
      <button className="registro-button" disabled>
        📲 Esperando lectura NFC...
      </button>
    </div>
  </div>
)}

      {showAlimentosNfcModal && (
        <div className="modal" onClick={() => setShowAlimentosNfcModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>{alimentosMode === 'end' ? 'Finalizar Alimentos' : 'Iniciar Alimentos'}</h2>
            <p>Acerque su tarjeta NFC para {alimentosMode === 'end' ? 'finalizar' : 'iniciar'} Alimentos.</p>
            <button className="registro-button" disabled>
              📲 Esperando lectura NFC...
            </button>
          </div>
        </div>
      )}


{showEntradaCredencialModal && (
  <div className="modal" onClick={() => setShowEntradaCredencialModal(false)}>
    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
      <h2>Registrar entrada con credencial y silla</h2>

      <div style={{ marginBottom: '1rem' }}>
        <label><strong>Escanear credencial</strong></label>
        <button onClick={handleScanCredencial} style={{ marginLeft: '10px' }}>
          🔄 NFC
        </button>
        <p>{credencialValidada ? '✅ Pulsera validada' : '⏳ Pendiente de escaneo'}</p>
      </div>

      
      <button
        className="registro-button"
        onClick={handleRegistrarEntradaCompleta}
d       isabled={!credencialValidada}
      >
        Registrar Entrada
      </button>
    </div>
  </div>
)}


      <ToastContainer />
    </div>
  );
};

export default BitacoraPage;
